var exports = {
  "button": "MediaPlayButton.module__button___X2xwQU",
  "small": "MediaPlayButton.module__small___X2xwQU",
  "medium": "MediaPlayButton.module__medium___X2xwQU",
  "large": "MediaPlayButton.module__large___X2xwQU",
  "xlarge": "MediaPlayButton.module__xlarge___X2xwQU",
  "iconContainer": "MediaPlayButton.module__iconContainer___X2xwQU",
  "spinner": "MediaPlayButton.module__spinner___X2xwQU",
  "spin": "MediaPlayButton.module__spin___X2xwQU",
  "overlay": "MediaPlayButton.module__overlay___X2xwQU",
};

__webpack_require__.r(module.exports = exports);
